export class BodyEmbedded {
    taskid: string;
    entityid: string;
    entitytype: string;
    username: string;
    useremail: string;
    timestamp: string;
    ignore: number = 0;
}